<template>
  <div class="columns">
    <div class="column is-3-fullhd is-5-tablet">
      <b-field label="Rango">
        <b-radio-button
          v-model="rangoTiempo"
          native-value="DAY"
          type="is-primary is-light is-outlined"
        >
          <span>Hoy</span>
        </b-radio-button>
        <b-radio-button
          v-model="rangoTiempo"
          native-value="WEEK"
          type="is-primary is-light is-outlined"
        >
          <span>Semana</span>
        </b-radio-button>
        <b-radio-button
          v-model="rangoTiempo"
          native-value="MONTH"
          type="is-primary is-light is-outlined"
        >
          Mes
        </b-radio-button>
        <b-radio-button
          v-model="rangoTiempo"
          native-value="CUSTOM"
          type="is-primary is-light is-outlined"
          disabled
        >
          Personalizado
        </b-radio-button>
      </b-field>
    </div>
    <div class="column is-2-fullhd is-2-tablet">
      <b-field label="Fecha Desde">
        <b-datepicker
          :value="desde"
          placeholder="Seleccionar..."
          :first-day-of-week="1"
          :date-formatter="
            (date) =>
              new Intl.DateTimeFormat('es', {
                day: '2-digit',
                year: 'numeric',
                month: '2-digit'
              }).format(date)
          "
          @input="fromInputHandle"
        >
        </b-datepicker>
      </b-field>
    </div>
    <div class="column is-2-fullhd is-2-tablet">
      <b-field label="Fecha Hasta">
        <b-datepicker
          :value="hasta"
          placeholder="Seleccionar..."
          :first-day-of-week="1"
          :date-formatter="
            (date) =>
              new Intl.DateTimeFormat('es', {
                day: '2-digit',
                year: 'numeric',
                month: '2-digit'
              }).format(date)
          "
          @input="toInputHandle"
        >
        </b-datepicker>
      </b-field>
    </div>
  </div>
</template>

<script>
import { previousMonday, nextSunday, lastDayOfMonth, isBefore } from 'date-fns'

export default {
  name: 'Filtros',
  data() {
    return {
      rangoTiempo: '',
      desde: null,
      hasta: null
    }
  },
  watch: {
    rangoTiempo(newValue) {
      if (newValue === 'CUSTOM') return
      this.setDateRange(newValue)
    }
  },
  mounted() {
    this.rangoTiempo = 'DAY'
  },
  methods: {
    setDateRange(range) {
      const today = new Date()
      switch (range) {
        case 'DAY':
          this.desde = today
          this.hasta = today
          break
        case 'WEEK':
          this.desde = previousMonday(today)
          this.hasta = nextSunday(today)
          break
        case 'MONTH':
          this.desde = new Date(today.getFullYear(), today.getMonth(), 1)
          this.hasta = lastDayOfMonth(today)
          break
        default:
          break
      }
      this.$emit('change', { desde: this.desde, hasta: this.hasta })
    },
    fromInputHandle(newValue) {
      this.rangoTiempo = 'CUSTOM'
      this.desde = newValue
      if (!isBefore(this.desde, this.hasta)) {
        this.hasta = newValue
      }
      this.$emit('change', { desde: this.desde, hasta: this.hasta })
    },
    toInputHandle(newValue) {
      this.rangoTiempo = 'CUSTOM'
      this.hasta = newValue
      if (!isBefore(this.desde, this.hasta)) {
        this.desde = this.hasta
      }
      this.$emit('change', { desde: this.desde, hasta: this.hasta })
    }
  }
}
</script>
